import {t} from 'app/translations';
import {EskotValidator} from 'utils/eskot-validator';
import {Errors} from 'utils/validator';

import {SubjectManagementFacilityFormValues} from '../types/subject-management-facility-form-values';

const te = t('admin');

/**
 * Builds validation for the breeder-management form.
 *
 * @param farmsRequired Whether the farm field must be filled.
 * @returns A validation function for breeder-management values.
 */
export const createManagementBreedersValidate = (farmsRequired: boolean) =>
    (values: SubjectManagementFacilityFormValues): Errors<SubjectManagementFacilityFormValues> => {
        const validator = new EskotValidator(values);

        const approveIsInvalid = (
            values.approvedFrom !== null
            && values.approvedTo !== null
            && values.approvedFrom > values.approvedTo
        );

        validator.customRule(
            'approvedTo',
            approveIsInvalid,
            te('dateFromToIsInvalid'),
        );

        validator.nonEmpty('approvedFrom', te('approvedFrom'));
        validator.nonEmpty('userProfileId', te('loginName'));
        if (farmsRequired) validator.nonEmpty('farmIds', te('farms'));
        validator.nonEmpty('roleIds', te('roles'));

        return validator.generateErrorsObject();
    };
